// event-bus.js
import Vue from 'vue';


const AlertEventBus = new Vue(); 
export default AlertEventBus; 
 
 
//listen on event fired - you could use this to log or debug the total system.. 
AlertEventBus.$on('show-alert', (payload: any) => { 
    console.log('something is happening..'); 
}); 
 

export class IAlert{
    header:string;
    message: string;
}
